import { message, notification } from 'antd';
import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

function withHooks(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        const searchParams = new URLSearchParams(window.location.search);
        const [messageApi, contextHolder] = message.useMessage();
        const [notificationApi, notificationContextHolder] = notification.useNotification();

        return (
            <Component
                {...props}
                navigate={navigate}
                location={location}
                params={params}
                searchParams={searchParams}
                messageApi={messageApi}
                contextHolder={contextHolder}
                notificationApi={notificationApi}
                notificationContextHolder={notificationContextHolder}
            />
        );
    };
}

export default withHooks;
